"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _WeatherCode = _interopRequireDefault(require("./WeatherCode"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StationPlotLegend =
/** @class */
function () {
  function StationPlotLegend() {}

  StationPlotLegend.prototype.render = function (obs) {
    var windSpeed = (0, _utils.roundToInterval)(obs.windSpeedKTS, 5);
    var windGust = (0, _utils.roundToInterval)(obs.windGustKTS, 5);
    var direction = obs.windDirDEG;
    var weather = new _WeatherCode.default(obs.weatherPrimaryCoded, obs);
    return "\n\t\t\t<g class=\"wind-barb-legend\">\n\t\t\t\t" + this.stationId() + "\n\t\t\t\t" + this.temp() + "\n\t\t\t\t" + this.pressure() + "\n\t\t\t\t" + this.dewpoint() + "\n\t\t\t\t" + this.skyCover() + "\n\t\t\t\t" + this.wind(windSpeed, windGust, direction) + "\n\t\t\t\t" + (weather.icon && this.weatherCode()) + "\n\t\t\t</g>\n\t\t";
  };

  StationPlotLegend.prototype.stationId = function () {
    return "\n\t\t\t" + (0, _utils.text)('Station ID', 35, 33) + "\n\t\t\t" + (0, _utils.line)(30.5, 31, 30, 30) + "\n\t\t";
  };

  StationPlotLegend.prototype.temp = function () {
    return "\n\t\t\t" + (0, _utils.text)('Temp (F)', 17, 13) + "\n\t\t\t" + (0, _utils.line)(14.5, 14, 15, 15) + "\n\t\t";
  };

  StationPlotLegend.prototype.pressure = function () {
    return "\n\t\t\t" + (0, _utils.text)('Sea Level Pressure (mB)', 35, 13) + "\n\t\t\t" + (0, _utils.line)(30, 14, 29.5, 15) + "\n\t\t";
  };

  StationPlotLegend.prototype.dewpoint = function () {
    return "\n\t\t\t" + (0, _utils.text)('Dew Point (F)', 17, 33) + "\n\t\t\t" + (0, _utils.line)(14.5, 31, 15, 30) + "\n\t\t";
  };

  StationPlotLegend.prototype.wind = function (windSpeed, windGust, direction) {
    var rotation1 = direction > 90 && direction < 270 ? direction - 180 : direction;
    var rotation2 = direction > 90 && direction < 270 ? 180 - direction : 360 - direction;
    var translation = direction > 90 && direction < 270 ? 19 : -19;
    return "\n\t\t\t<g transform=\"rotate(" + (rotation1 || 0) + " 12 12) translate(0 " + translation + ") rotate(" + (rotation2 || 0) + " 12 12)\">\n\t\t\t\t" + (0, _utils.text)('Wind', 23, 22.5, {
      anchor: 'middle'
    }) + "\n\t\t\t\t" + (windGust > windSpeed && (0, _utils.text)('(Gust)', 23, 24, {
      fill: 'red',
      anchor: 'middle'
    })) + "\n\t\t\t</g>\n\t\t";
  };

  StationPlotLegend.prototype.skyCover = function () {
    return "\n\t\t\t" + (0, _utils.text)('Sky Cover', 22, 32, {
      anchor: 'middle'
    }) + "\n\t\t\t" + (0, _utils.text)('&', 22, 33.5, {
      anchor: 'middle'
    }) + "\n\t\t\t" + (0, _utils.text)('Flight Rule', 22, 35, {
      anchor: 'middle'
    }) + "\n\t\t\t" + (0, _utils.line)(22, 30, 22, 26) + "\n\t\t";
  };

  StationPlotLegend.prototype.weatherCode = function () {
    return "\n\t\t\t" + (0, _utils.text)('Weather', 11, 22.5, {
      link: 'https://www.aviationweather.gov/metar/symbol'
    }) + "\n\t\t\t" + (0, _utils.line)(11.5, 22, 13, 22) + "\n\t\t";
  };

  return StationPlotLegend;
}();

var _default = StationPlotLegend;
exports.default = _default;
module.exports = exports.default;